import { createContext, useContext, useState, useEffect } from "react";
import { t as translate } from "../translations";

const LanguageContext = createContext(null);
const LANG_KEY = "piikk_lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(LANG_KEY) || "en");

  const toggle = () => {
    const next = lang === "en" ? "hi" : "en";
    setLang(next);
    localStorage.setItem(LANG_KEY, next);
  };

  const t = (key, vars = {}) => translate(key, lang, vars);

  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
